import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-claro-mini-image-button',
  templateUrl: './claro-mini-image-button.component.html',
  styleUrls: ['./claro-mini-image-button.component.scss']
})
export class ClaroMiniImageButtonComponent extends BaseComponent implements OnInit {

  @Input() image = "assets/common/quickActions/Performance.svg";
  @Input() isSelected :boolean = false;
  @Input() isToggle :boolean = false;
  @Input() isHighlighted : boolean = false;
  
  @Output() clickEvent = new EventEmitter();

  containerBkgrndColor = "";

  constructor() { 
    super()
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (this.isHighlighted){
      // this.containerBkgrndColor = "#FDDBD9";
    }
  }

  containerClicked(): void{
    if (this.isToggle){
      this.isSelected = !this.isSelected;
    }
    else if (!this.isSelected){
      this.isSelected = true;
    }
    
    this.clickEvent.emit();
  }

}
